// extracted by mini-css-extract-plugin
export var shake = "_1i-0";